import React, { Component } from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { Link, useNavigate } from "react-router-dom";
import Button from "../../../shared/components/button/button";
import InputFieldComponent from "../../../shared/components/forms/input-field/input-field";
import Modal from "../../../shared/components/modal/modal";

import {
  mapStateToPropsTenantsList,
  Props,
  State,
  updateTenantObj,
} from "../../../shared/interfaces/components/tenantList.interface";
import { Tenant } from "../../../shared/interfaces/model/tenant.interface";
import * as actions from "../../../store/tenant/action";
import InputMultiSelectComponent from "../../../shared/components/forms/multi-select/multi-select-input";
import { SelectOptions } from "../../../shared/interfaces/components/form.interface";
import Navbar from "../../../shared/components/navbar";
import Sidebar from "../../../shared/components/sidebar";
import MainLayout from "../../../shared/components/MainLayout";
import Loader from "../../../shared/components/loader/Loader";
import UserTable from "../components/UserTable";

const messageWarning1 =
  "Non è possibile aggiornare perché il formato della mail non è corretto";
const messageWarning2 =
  "Non è possibile aggiornare perché i parametri inseriti sono già stati salvati";

let responseCode = 0;
let responseData = "";

export const recoverResponseCode = async (code: number) => {
  responseCode = code;
};

export const recoverResponseData = async (message: string) => {
  responseData = message;
};

class UserList extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      ...props,
      ids: [""],
      pages: { numPage: 0, id: "" },
      counter: 0,
      showUpdate: false,
      showDetail: false,
      showDelete: false,
      showOps: false,
      currentTenant: { id: "", organizationName: "", organizationEmail: "" },
      notUpdatableTenant: true,
      orgNameEntered: "",
      orgEmailEntered: "",
      loading: false,
      emailStored: "",
      nameStored: "",
      invalidEmail: false,
      product: [],
      productString: [],
      newCompanyName: "",
      newVAT: "",
      newDestinationCode: "",
      newPec: "",
    };
  }

  componentDidMount() {
    // retrieves the role value
    if (this.props.role) window.localStorage.setItem("role", this.props.role);
    const extractRole = window.localStorage.getItem("role") ?? "";

    // extract token from cookies
    const tokenSession = window.localStorage.getItem("token");

    // get tenant list
    if (extractRole !== "") {
      const role = JSON.parse(extractRole);
      if (tokenSession && role === 0) {
        this.props.getTenantsListRequest(this.state.pages.id);
      }
      if (role === 1 || role === 2) {
        this.props.location("/");
      }
    }
  }

  componentDidUpdate(prevProps: Props) {
    if (this.props.detailsTenant !== prevProps.detailsTenant) {
      this.props.location(`/Private/detailstenant/?id=${""}`);
    }

    if (this.props.deleteTenant !== prevProps.deleteTenant) {
      window.location.reload();
    }
  }

  render() {
    // destructuring state
    const { counter, ids, showDelete, showDetail, showUpdate, showOps } =
      this.state;

    // destructuring Props
    const { tenantListIsOk, tenantsList, idPage, role } = this.props;

    // get details tenant
    const getDetailTenant = (tenantId: string | undefined) => {
      if (tenantId) {
        if (this.props.getTenantsDetailRequest) {
          const newTenantId = window.localStorage.getItem("tenantId");
          this.props.getTenantsDetailRequest(newTenantId || "");
        }
      }
    };

    const changeState = (newCounter: number) => {
      const currentId = idPage ?? "";
      if (tenantListIsOk) {
        this.setState((prevState) => ({
          ids: [...prevState.ids, currentId],
          pages: { ...prevState.pages, numPage: newCounter, id: idPage },
          counter: newCounter,
        }));
      }
    };

    const nextPage = () => {
      changeState(counter + 1);
      this.props.getTenantsListRequest(idPage);
    };

    const prevPage = () => {
      changeState(counter - 1);
      this.props.getTenantsListRequest(ids[counter - 1]);
    };

    const showModal = (but: number) => {
      if (but === 1) {
        this.setState((prevState) => ({
          showUpdate: true,
        }));
      }
      if (but === 2) {
        this.setState((prevState) => ({
          showDelete: true,
        }));
      }
      if (but === 3) {
        this.setState((prevState) => ({
          showOps: true,
        }));
      }
    };

    const hideModal = () => {
      this.setState((prevState) => ({
        showUpdate: false,
        showDelete: false,
        showOps: false,
        productString: [],
        product: [],
      }));
    };

    const deleteTenantRow = (id: string) => {
      this.setState((prevState) => ({
        ...prevState,
        loading: true,
      }));
      if (id) this.props.deleteTenantRowRequest(id);
      setTimeout(() => {
        window.location.reload();
      }, 8000);
    };

    const updateTenantRow = (updateTenantParam: updateTenantObj) => {
      if (updateTenantParam) {
        this.props.updateTenantRowRequest(updateTenantParam);
      }
    };

    const changeCurrentTenant = (newTenant: Tenant) => {
      this.setState((preState) => ({
        currentTenant: newTenant,
        notUpdatableTenant: true,
      }));

      const productList: SelectOptions[] = [];
      const productListString: string[] = [];
      if (Array.isArray(newTenant.product)) {
        newTenant.product.forEach((element: string) => {
          productList.push({ id: element, value: element });
          productListString.push(element);
        });
        this.setState((preState) => ({
          product: productList,
          productString: productListString,
        }));
      } else if (newTenant.product !== "" && newTenant.product !== undefined) {
        productList.push({ id: newTenant.product, value: newTenant.product });
        productListString.push(newTenant.product);
        this.setState((preState) => ({
          product: productList,
          productString: productListString,
        }));
      }
    };

    const changeNotUpdatableTenant = (newNotUpdatableTenant: boolean) => {
      this.setState((prevState) => ({
        notUpdatableTenant: newNotUpdatableTenant,
      }));
    };

    const changeOrgNameEntered = (newOrgNameEntered: string) => {
      this.setState((prevState) => ({
        orgNameEntered: newOrgNameEntered,
      }));
    };

    const changeOrgEmailEntered = (newEmailEntered: string) => {
      this.setState((prevState) => ({
        orgEmailEntered: newEmailEntered,
      }));
    };

    const changeEmailStored = (newEmailStored: string) => {
      this.setState((prevState) => ({
        emailStored: newEmailStored,
      }));
    };

    const changeNameStored = (newNameStored: string) => {
      this.setState((prevState) => ({
        nameStored: newNameStored,
      }));
    };

    const changeInvalidEmail = (newInvalidEmail: boolean) => {
      this.setState((prevState) => ({
        invalidEmail: newInvalidEmail,
      }));
    };

    const verifyOrgNameEnteredBeforeUpdate = (
      data: React.ChangeEvent<HTMLInputElement>
    ) => {
      changeNotUpdatableTenant(false);
      changeOrgNameEntered(data.target.value);
      if (
        data.target.value === "" ||
        (data.target.value === this.state.currentTenant.organizationName &&
          this.state.emailStored === this.state.orgEmailEntered) ||
        this.state.orgEmailEntered === ""
      ) {
        changeNotUpdatableTenant(true);
      }
    };

    const verifyOrgEmailEnteredBeforeUpdate = (
      data: React.ChangeEvent<HTMLInputElement>
    ) => {
      const regex = /[a-z0-9.-_]+@[a-z0-9.-]+\.[a-z]{2,3}/;
      changeInvalidEmail(false);
      changeNotUpdatableTenant(false);
      changeOrgEmailEntered(data.target.value);
      if (
        data.target.value === "" ||
        (data.target.value === this.state.currentTenant.organizationEmail &&
          this.state.nameStored === this.state.orgNameEntered) ||
        this.state.orgNameEntered === ""
      ) {
        changeNotUpdatableTenant(true);
      }
      if (!regex.test(data.target.value)) {
        changeInvalidEmail(true);
        changeNotUpdatableTenant(true);
      }
    };

    const productsChange = (data: SelectOptions[]) => {
      if (data !== undefined) {
        const lista: string[] = [];
        data.map((item) => lista.push(item.value.toString()));
        this.setState((preState) => ({
          product: data,
          productString: lista,
        }));

        if (lista.length === 0 || lista === this.state.currentTenant.product) {
          changeNotUpdatableTenant(true);
        } else {
          changeNotUpdatableTenant(false);
        }
      }
    };

    const setLoading = (newLoading: boolean) => {
      this.setState((prevState) => ({
        loading: newLoading,
      }));
    };
    const fetchData = () => {
      setLoading(true);

      setTimeout(() => {
        setLoading(false);
        if (responseCode === 0) responseCode = 500; // temporany
        if (responseData === "") responseData = "ServerError"; // temporany
        showModal(3);
      }, 4000);
    };

    return (
      <MainLayout>
        <Loader isLoading={!Boolean(tenantListIsOk) || this.state.loading} />
        <div className="" data-test="tenantList">
          <section className="p-2 md:p-10 w-full box-border flex flex-row flex-wrap justify-center">
            <article className="between-xs row col-xs-12 tenantList--title middle-xs">
              <p className="text-2xl font-bold">User List</p>
            </article>
            {tenantListIsOk && tenantsList && (
              <UserTable
                tenantsList={tenantsList}
                tenantListIsOk={tenantListIsOk}
                changeCurrentTenant={changeCurrentTenant}
                getDetailTenant={getDetailTenant}
                deleteTenantRow={deleteTenantRow}
              />
            )}
          </section>
        </div>
      </MainLayout>
    );
  }
}

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  getTenantsListRequest: (payload?: string) => {
    dispatch(actions.getTenantsListRequest(payload));
  },
  getTenantsDetailRequest: (payload: string) => {
    dispatch(actions.getDetailsTenantRequest(payload));
  },
  deleteTenantRowRequest: (payload: string) => {
    dispatch(actions.deleteUserRowRequest(payload));
  },
  updateTenantRowRequest: (payload: updateTenantObj) => {
    dispatch(actions.updateTenantRowRequest(payload));
  },
});
const mapStateToProps = (state: mapStateToPropsTenantsList) => ({
  tenantsList: state.tenantsReducer?.tenantsList?.tenants,
  idPage: state.tenantsReducer?.tenantsList?.last,
  tenantListIsOk: state.tenantsReducer?.tenantListIsOk,
  detailsTenant: state.tenantsReducer?.detailsTenant,
  deleteTenant: state.tenantsReducer?.deleteTenant,
  // TODO add response prop
});

export default connect(mapStateToProps, mapDispatchToProps)(UserList);
